export default "__VITE_ASSET__C$RjyXdU__"